import { EmailBannerForm } from "@lululemon/ecom-common/src/components/email-banner/banner-form/email-banner-form";
export default EmailBannerForm;
